import LinkListCard from '../../common/LinkListCard/LinkListCard';
import {
  DashboardHeader,
  DashboardLinks,
  DashboardPage,
  FilterWrapper,
  H1,
  QuickStart,
  QuickStartButtons,
} from './Dashboard.styles';
import DashboardButton from './DashboardButton/DashboardButton';
import { Security } from '../../services/auth/auth.types';
import { useUser } from '../../services/auth/auth.service';
import Autocomplete from '../../components/Autocomplete/Autocomplete';
import { useNavigate } from 'react-router-dom';
import { Link } from '../../common/Navigation/NavigationMenu/NavigationMenu.types';

const Dashboard = () => {
  const navigate = useNavigate();
  const { data: userData } = useUser(true);
  const user = userData?.data;

  const productClassificationsOptions: Link[] = [
    { to: '/tables/classes', label: 'Class' },
    { to: '/tables/bases', label: 'Base' },
    { to: '/tables/sizes', label: 'Size' },
    { to: '/tables/products', label: 'Product' },
    { to: '/tables/classbases', label: 'ClassBase' },
    { to: '/tables/classsizes', label: 'ClassSize' },
    { to: '/tables/options', label: 'Option' },
  ];

  const storeManagementOptions: Link[] = [
    // { to: '/tables/dsc', label: 'DSC' },
    { to: '/storecontrol', label: 'Store Control' },
    { to: '/tables/storeinfo', label: 'Store Details' },
    { to: '/tables/coupons', label: 'Coupons' },
    { to: '/tables/coupon-groups', label: 'Coupon Groups' }
  ];

  const miscellaneousOptions: Link[] = [{ to: '/tables/users', label: 'User' }];

  const menuManagementOptions: Link[] = [
    { label: 'Combo Topping', to: '/tables/combotopping', testId: 'tableLinkComboTopping' },
    { label: 'Criteria', to: '/tables/criteria', testId: 'tableLinkCriteria' },
    { label: 'Date Range', to: '/tables/dateranges', testId: 'tableLinkDateRange' },
    { label: 'Mandatory Inventory Group', to: '/tables/mandatoryinventory', testId: 'tableLinkManInvGroup' },
    { label: 'Occasion', to: '/tables/occasions', testId: 'tableLinkOccasions' },
    { label: 'Raw Product', to: '/tables/rawproducts' },
    { label: 'Raw Product GINs', to: '/tables/rawprodgins', testId: 'tableLinkRawProdGins' },
    { label: 'Strategy', to: '/tables/strategies', testId: 'tableLinkStrategy' },
    { label: 'Time', to: '/tables/times', testId: 'tableLinkTime' },
    { label: 'Day', to: '/tables/days', testId: 'tableLinkDay' },
    { label: 'Product Group', to: '/tables/productgroups' },
    { label: 'Product Group Detail', to: '/tables/productgroupdetails', testId: 'tableLinkProductGroupDetail' },
    { label: 'QSR Department', to: '/tables/qsrdept', testId: 'tableLinkQsrDept' },
  ];

  const searchBarOptions: Link[] = [
    ...productClassificationsOptions.map(option => ({
      ...option,
      value: option.to,
    })),
    ...menuManagementOptions.map(option => ({
      ...option,
      value: option.to,
    })),
    ...storeManagementOptions.map(option => ({
      ...option,
      value: option.to,
    })),
    ...miscellaneousOptions.map(option => ({
      ...option,
      value: option.to,
    })),
  ];


  const handleFilterChange = (value: { value: string }) => {
    if (value && value.value) {
      navigate(`${value.value}`);
    }
  };
  return (
    <DashboardPage>
      <DashboardHeader>
        <H1 data-testid="tablesDashboardHeader">Welcome to Menu Operations & Assembly</H1>
        <QuickStart>
          <QuickStartButtons>
            <DashboardButton data-testid="quickStartMenu" to="/menus" id="skipNavTarget">
              Menus
            </DashboardButton>
            <DashboardButton data-testid="quickStartExtract" to="/extract">
              Extract
            </DashboardButton>
            <DashboardButton data-testid="quickStartStoreControl" to="/storecontrol">
              Store Control
            </DashboardButton>
            <DashboardButton data-testid="quickStartRecipes" to="/recipes">
              Recipes
            </DashboardButton>
          </QuickStartButtons>
          <FilterWrapper>
            <Autocomplete label={"Search"} isLabelHeader={true} id="" options={searchBarOptions.filter(value => {
              if (value.label === 'User') {
                return user?.security === Security.Admin;
              }
              return true;
            })} onChange={handleFilterChange} disabled={false} />
          </FilterWrapper>
        </QuickStart>
      </DashboardHeader>
      <DashboardLinks>
        <LinkListCard
          links={productClassificationsOptions}
          title="Product Classifications"
        />
        <LinkListCard
          links={menuManagementOptions}
          title="Menu Management"
        />
        <LinkListCard
          links={storeManagementOptions}
          title="Store Management"
        />
        {user?.security === Security.Admin && (
          <LinkListCard links={miscellaneousOptions} title="Miscellaneous" />
        )}
      </DashboardLinks>
    </DashboardPage>
  );
};

export default Dashboard;
